export default "__VITE_ASSET__C1RW4cPT__"